import * as React from 'react'

export const MapIcon = () => (
  <svg width={15} height={12} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m10 11.746-5-1.402V.504l5 1.402v9.84Zm.833-.03V1.844l3.31-1.3a.623.623 0 0 1 .857.57v8.55c0 .251-.156.476-.393.57l-3.774 1.48v.002Zm-10.44-9.7L4.167.536v9.87l-3.31 1.3a.623.623 0 0 1-.857-.57v-8.55c0-.251.156-.476.393-.57Z"
      fill="currentColor"
    />
  </svg>
)

export default MapIcon
